import {useNavigate} from "react-router-dom";
import useSwipe from "../../hooks/useSwipe";
import {Box} from "@mui/material";

// @ts-ignore
const Page = ({children}) => {

    const navigate = useNavigate()
    const swipeHandlers = useSwipe({ onSwipedRight: () => navigate('/') });

    return (
      <Box {...swipeHandlers} mb={2}>
          {children}
      </Box>
    );
}

export default Page;